class HastaRaporSonuclariHastaListesiDTO {
    id: number = 0;
    hastaRaporId?: number = null;
    hastaRaporTarih?: string = "";
    hastaAdiSoyadi?: string = "";
};
export default HastaRaporSonuclariHastaListesiDTO;